export class DispatchSidModel {
  public sidNo: string;
  public updatedUser: string;
  public appRefNo: number;
}
